module.exports = __webpack_public_path__ + "img/p64.9b0dcac4.jpg";